import React from "react"
import { createStyles, forwardRef } from "@design-system/core"
import { ViewLink } from "@design-system/link"
import { useInteractive } from "@design-system/interactive"
import { TabProps } from "./types"
import { useTabsContext } from "./TabsContext"

export const Tab = forwardRef<TabProps, "div">((props, forwardedRef) => {
  const { selectedIndex } = useTabsContext()

  const { children, style, index, ...otherProps } = props
  const {
    isDisabled,
    isHovered,
    isPressed,
    isFocused,
    ...interactiveProps
  } = useInteractive(otherProps)

  const isActive = index === selectedIndex

  return (
    <ViewLink
      accessibilityRole="tab"
      {...interactiveProps}
      ref={forwardedRef}
      style={[
        styles.link,
        style,
        // isActive && styles.active,
        !isActive && isHovered && styles.hover,
      ]}
    >
      {children}
    </ViewLink>
  )
})

Tab.displayName = "Tab"

const styles = createStyles((theme) => ({
  link: {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    justifyContent: "center",
    borderBottomWidth: theme.borderWidths.small,
    borderBottomStyle: "solid",
    borderBottomColor: theme.borderColors.transparent,
    outlineStyle: "none",
    paddingVertical: theme.spaces.spacing12,
    paddingHorizontal: theme.spaces.spacing8,
    cursor: "pointer",
    marginBottom: -1,
  },
  // active: {
  //   borderBottomColor: theme.borderColors.selection,
  //   color: theme.textColors.link,
  //   fontWeight: theme.fontWeights.semibold,
  // },
  hover: {
    borderBottomColor: theme.borderColors.hover,
  },
}))
